import { Fragment, useContext } from "react";
import { Box } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import { AppPagination, ParagraphText } from "../../../../Libraries";
import { FilterNonIdeal } from "../../../common";
import { InvoiceBookNonIdeal } from "../../../common/NewNonIdeal";
import { PendingPaymentNonideal } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import TableHeader from "./TableHeader";
import ItemList from "./ItemList";
import NonIdealNew from "../../../common/NonIdealNew";

const PendingPayments = ({
  list = [],
  totalCount,
  setPageSize,
  filters,
  handleAscending,
  isLoading,
  debounceSearchName,
  isAppliedFilter,
  initialFilters,
  handleSetFilter,
  allNonFilterItemsCount,
  onCollectionDateUpdated,
}) => {
  const [I18n] = useContext(LanguageContext);

  const handleClearFilter = () => {
    triggerLogEvent(analytics, "w_payments_filter_reset");
    handleSetFilter(initialFilters, "");
  };

  const searchTrimmed = (debounceSearchName || "").trim();

  if (allNonFilterItemsCount === 0) {
    return (
      <InvoiceBookNonIdeal
        title={
          <ParagraphText className="textCenter fontSize18">
            {I18n.pending_collections_payments}
          </ParagraphText>
        }
        subTitle={
          <ParagraphText className="textCenter fontSize14 grayNewShade">
            {I18n.nonIdealPendingCollectionSubtitle}
          </ParagraphText>
        }
        icon={<PendingPaymentNonideal />}
      />
    );
  }

  return (
    <Fragment>
      <TableHeader
        filters={filters}
        handleAscending={handleAscending}
        disabled={!list.length}
      />
      {list.length > 0 ? (
        <Box
          className="pendingItemListWrapper generic-scrollbar"
          id="scrollableDiv"
        >
          <AppPagination
            data={{
              handleNext: () => {
                setPageSize((value) => value + 20);
              },
              pageLoad: isLoading,
              count: totalCount,
              list,
              scrollableTarget: "scrollableDiv",
            }}
          >
            {list.map((item, i) => (
              <ItemList
                key={item?.id ?? i}
                detail={item}
                onCollectionDateUpdated={onCollectionDateUpdated}
              />
            ))}
          </AppPagination>
        </Box>
      ) : searchTrimmed && !isAppliedFilter ? (
        <FilterNonIdeal
          title={
            <>
              {I18n.we_could_not_find_match}
              <b>&apos;{searchTrimmed}&apos;</b>
            </>
          }
          subTitle={I18n.try_adjusting_filters}
        />
      ) : !isLoading ? (
        <Box className="h-100">
          {isAppliedFilter ? (
            <FilterNonIdeal
              title={I18n.no_result_found}
              subTitle={I18n.try_adjusting_filters}
              subTitleTextOnClick={handleClearFilter}
              subTitleText={I18n.reset_small}
            />
          ) : (
            <NonIdealNew
              title={I18n.no_result_found}
              subtitle={I18n.you_dont_have_any_pending_collections}
            />
          )}
        </Box>
      ) : null}
    </Fragment>
  );
};

export default PendingPayments;
